
<div class="main-content">
<router-outlet></router-outlet>
</div>
